//DSS Documentation on Angular Components - http://tiny.sc/cgangularcomponent
import { Component, EventEmitter, OnInit, AfterViewInit, Input, Output, Pipe, PipeTransform, HostListener } from '@angular/core';
import { NgModule } from '@angular/core';
//import { ViewChild, ElementRef } from '@angular/core';
import { DatePipe } from '@angular/common';
import { SocoHttpService } from '@soco/http';
import { DBTraceLogService } from '../../services/dbTraceLog/dbTraceLog.service';
import { CoolEmailService } from '../../services/coolEmail/coolEmail.service';
import { AppCommonService } from '../../services/common/app-common.service';
import { AvailabilityService } from './availability-selection.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import {   
    RescheduleEligibility, AvailabilityDates, NoGasClickOrderModel, AvailabilityRequest
} from './availability-selection-entities';
import { DBTraceLog, LogType } from '../../services/dbTraceLog/dbTraceLog-entities';
import { AppConfigurationData } from '../../services/common/app-common-entities';
import { AvailabilityInput, AvailabilityOutput } from './availability-selection-entities';
import { AppBaseComponent } from '../base/app-base.component';


@Component({
    selector: 'availability-selection',
    templateUrl: 'availability-selection.component.html',
    styleUrls: ['availability-selection.component.css'],
    providers: [DatePipe, AvailabilityService, DBTraceLogService, AppCommonService]
})
export class AvailabilityComponent extends AppBaseComponent implements OnInit {

    //#region Variables
    public ldc: string = '';
    public seedDate: string;
    public orderNumber: string = '';
    public premiseNumber: string = '';
    public availabilityResponse: any;
    public urlCode: string;
    public sentinelAvailableDays = [];
    public timeSlots = [];
    public filteredTimeSlots = [];
    public selectedTimeSlot: string;
    public selectdScheduleDate: string;
    public selectedScheduleWindow: string;
    public selectedTimeSlotWindow: string;
    public ccbAppointmentStart: string;
    public ccbAppointmentEnd: string;
    public data: any;
    public isPageLoadReady: boolean = false;
    public showSpinner: boolean = true;    
    public errorInfo: any;
    public showTimeSlotLoadingSpinner: boolean = false;    
    public rescheduleEligibility: RescheduleEligibility;    
    public availabilityRequest: AvailabilityRequest;
    public availabilityDates: Array<AvailabilityDates> = [];    
    public objAvailabilityDates: AvailabilityDates;
    public firstSentinelAvailableDate: string = '';
    public maxAvailableDatesAllowed: number = 0;
    public orderType: any = '';
    public personID: string = '';
    public eligibilityReturnMessage: string = '';
    public matchOrderEffectiveDate: string = '';
    public showTimeSlots: boolean = true;
    public appConfigurationDataList: Array<AppConfigurationData> = [];
    public noGasClickOrderModel: NoGasClickOrderModel;
    public noGasClickOrderModelList: any;
    
    public contactPhoneNo: string = '';
    public contactHours: string = '';

    public deviceInfo = null;
    public dbTraceLog: DBTraceLog;
    public logReferenceID: string = '';
    public entranceCodeReminderMsg: string = '';
    public portalTypeID: number = 0;    
    public availabilityOutput: AvailabilityOutput;
    public emailToList: string;
    public appointmentType: string = '';

    @Input() availabilityInput: AvailabilityInput;
    @Output() availabilitySelectionEvent = new EventEmitter<AvailabilityOutput>();
    @Output() processErrorEvent = new EventEmitter();

    //#endregion

    constructor(public availabilityService: AvailabilityService,
        public datepipe: DatePipe, public http: SocoHttpService,
        public dbTraceLogService: DBTraceLogService,
        public deviceService: DeviceDetectorService,
        public coolEmailService: CoolEmailService,
        private appCommonService: AppCommonService) {

        //Parent component initialization
        super(http, dbTraceLogService, coolEmailService, deviceService);

        this.availabilityOutput = new AvailabilityOutput();
    };

    ngOnInit() {

        //Change hard coded value to config driven in later development
        this.maxAvailableDatesAllowed = 45;

        //Get availability input from parent
        this.GetAvailabilityInput();

        //Load availability
        if (this.appointmentType === 'Issue') {            
            //Not checking eligibility rules while issuing as is it is new order/appt
            this.seedDate = this.datepipe.transform(Date.now(), "yyyy-MM-dd");
            this.GetAvailability(this.seedDate, true);
        }
        else {
            //If it's scheduling and AGLC LDC no need to check avilability eligibility rules (for now.. in future this may change for DM, Prorate ?)            
            this.GetRescheduleEligibilityOnLanding();
        }
    }

    // #region Availability Core Methods

    //Get availability from respective backend services
    GetAvailability(seedDate: string, isInitialCall: boolean) {
        try {
            this.availabilityRequest = new AvailabilityRequest();

            this.availabilityRequest.ldc = this.ldc;
            this.availabilityRequest.orderNumber = this.orderNumber;
            this.availabilityRequest.premisesNumber = this.premiseNumber;
            this.availabilityRequest.seedDate = this.datepipe.transform(seedDate, "MMddyyyy");
            this.availabilityRequest.entranceInstructionCode = this.availabilityInput.entranceInstructionCode;
            this.availabilityRequest.entranceInstructionProfile = this.availabilityInput.entranceInstructionProfile;

            this.availabilityRequest.accountNumber = this.availabilityInput.accountNumber;
            this.availabilityRequest.activityOrProblemType = this.availabilityInput.activityOrProblemType;
            this.availabilityRequest.isOverride = false;
            this.availabilityRequest.orderCategory = this.availabilityInput.orderCategory;
            this.availabilityRequest.serviceOrderActiontype = this.availabilityInput.serviceOrderActiontype;
            this.availabilityRequest.serviceOrderReason = this.availabilityInput.serviceOrderReason;
            this.availabilityRequest.serviceOrderType = this.availabilityInput.serviceOrderType;
            this.availabilityRequest.specialDateCodeID = this.availabilityInput.specialDateCodeID;

            this.insertDBTraceLog(LogType.Info, 'Availability fetch initiated for seed date: ' + this.availabilityRequest.seedDate);

            this.availabilityService.getAvailability(this.availabilityRequest).subscribe(ApiResult => {

                    if (ApiResult.data != null && ApiResult.statusCode == 200) {

                    this.insertDBTraceLog(LogType.Info, 'Availability fetched successfully for seed date: ' + this.availabilityRequest.seedDate);

                    this.availabilityResponse = ApiResult;

                    //Prepare local object from APIResult
                    this.availabilityResponse.data.availableDays.forEach(availableDay => {

                        //Do not push available day if it's already exist during subsequent sentinel call
                        if (this.sentinelAvailableDays.length == 0 ||
                            (this.sentinelAvailableDays.length > 0 && !this.sentinelAvailableDays.some((el) => el.availableDate == this.datepipe.transform(availableDay.availableDate, "yyyy-MM-dd")))) {
                            //fix the date format and push into array
                            availableDay.availableDate = this.datepipe.transform(availableDay.availableDate, "yyyy-MM-dd");
                            this.sentinelAvailableDays.push(availableDay);
                        }
                    });


                    this.availabilityResponse.data.timeSlots.forEach(timeSlot => {
                        this.timeSlots.push(timeSlot);
                    });

                    //Load first day Timeslot
                    if (isInitialCall && this.sentinelAvailableDays.length > 0) {
                        this.LoadSelectedDayTimeSlots(null, this.sentinelAvailableDays[0]);
                    }

                    if (this.sentinelAvailableDays.length === 0)
                        this.insertDBTraceLog(LogType.Info, 'Availability initiated for seed date: ' + this.availabilityRequest.seedDate + ', but available days length is zero');

                    this.isPageLoadReady = true; // At this stage all API's are loaded and page is ready to load
                    this.showSpinner = false; // Stop the spinner and show page content 
                    if (this.showTimeSlotLoadingSpinner) this.showTimeSlotLoadingSpinner = false; // stop spinner after availability call
                }
                else {
                    this.insertDBTraceLog(LogType.Error, 'Error occured while fetching availability, APIResult is either Null or result is not 200 - Seed date: ' + this.availabilityRequest.seedDate);
                    this.processError();
                }

            }, ApiResult => {
                if (this.http.isInvalidResult(ApiResult) || this.http.isErrorResult(ApiResult) || this.http.isFailureResult(ApiResult)) {
                    //console.log('contactPhoneNo before function', contactPhoneNo);                    
                    this.insertDBTraceLog(LogType.Error, 'Error occured while fetching availability, APIResult is invalid - Seed date: ' + this.availabilityRequest.seedDate);
                    this.processError();
                }
            });

        }
        catch (e) {
            this.insertDBTraceLog(LogType.Info, 'Exception occured while fetching availability, for seed date: ' + this.availabilityRequest.seedDate + ', Error: ' + e.message.substring(0, 500));
        }

    }    
    
    /* Check if order is eligible to reschedule on selectedDate in case of matched orders - Where eligibiliy is decided based on schedule date. */
    GetRescheduleEligibilityOnSelectedDate(scheduleDate: any) {

        try {
            var strScheduleDate: string = '';

            if (scheduleDate != null && scheduleDate != '')
                strScheduleDate = this.datepipe.transform(scheduleDate, "MMddyyyy");

            //Check reschedule eligibility for selected date, this is check for matching order validations
            this.availabilityService.getRescheduleEligibility(this.ldc, this.orderNumber, this.premiseNumber, strScheduleDate).subscribe(ApiResult => {

                if (ApiResult.data != null) {
                    //this.orderType = ApiResult.data.serviceOrderType;
                    this.eligibilityReturnMessage = ApiResult.data.message;
                    this.matchOrderEffectiveDate = ApiResult.data.matchOrderEffectiveDate;

                    if (!ApiResult.data.isRescheduleEligible && this.matchOrderEffectiveDate != null) {
                        this.insertDBTraceLog(LogType.Info, 'Order is NOT eligible to reschedule for selected date: ' + strScheduleDate);
                        this.showTimeSlots = false;
                    }
                    else {
                        this.insertDBTraceLog(LogType.Info, 'Order is eligible to reschedule for selected date: ' + strScheduleDate);
                        this.showTimeSlots = true;
                        this.LoadFilteredTimeSlots(scheduleDate);
                    }

                    if (this.showTimeSlotLoadingSpinner) this.showTimeSlotLoadingSpinner = false; // stop spinner after eligibility call
                }
                else {
                    this.processError();
                }

            }, ApiResult => {
                if (this.http.isInvalidResult(ApiResult) || this.http.isErrorResult(ApiResult) || this.http.isFailureResult(ApiResult)) {
                    this.insertDBTraceLog(LogType.Error, 'Error occured while fetching reschedule eligibility for selected date: ' + strScheduleDate);
                    this.processError();
                }
            });

        }
        catch (e) {
            this.insertDBTraceLog(LogType.Error, 'Exception occured while checking reschedule eligibility on selected date, Error: ' + e.message.substring(0, 500));
        }
    }
    
    /* Check if order is eligible to reschedule on landing */
    GetRescheduleEligibilityOnLanding() {
        try {
          
            this.availabilityService.getRescheduleEligibility(this.ldc, this.orderNumber, this.premiseNumber, '').subscribe(ApiResult => {
                
                if (ApiResult.data != null) {
                    console.log('Eligibility Api Result: ', ApiResult.data);

                    //this.orderType = ApiResult.data.serviceOrderType;
                    this.eligibilityReturnMessage = ApiResult.data.message;
                    this.matchOrderEffectiveDate = ApiResult.data.matchOrderEffectiveDate;

                    if (ApiResult.data.isRescheduleEligible || this.matchOrderEffectiveDate != null) {
                        //Load initial availability
                        //this.seedDate = this.datepipe.transform(ApiResult.data.orderEffectiveDate, "MMddyyyy");
                        this.insertDBTraceLog(LogType.Info, 'Order is eligible to reschedule on landing');
                        this.seedDate = this.datepipe.transform(Date.now(), "yyyy-MM-dd");
                        this.GetAvailability(this.seedDate, true);
                    }
                    else {
                        //Show error message if order is not in amendable status
                        this.insertDBTraceLog(LogType.Info, 'Order is NOT eligible to reschedule on landing');
                        this.processError();
                    }
                }
                else {
                    this.insertDBTraceLog(LogType.Error, 'Error occured while fetching reschedule eligibility on landing, API Result is Null');
                    this.processError();
                }

            }, ApiResult => {
                if (this.http.isInvalidResult(ApiResult) || this.http.isErrorResult(ApiResult) || this.http.isFailureResult(ApiResult)) {
                    this.insertDBTraceLog(LogType.Error, 'Error occured while fetching reschedule eligibility on landing');
                    this.processError();
                }
            });

        }
        catch (e) {
            this.insertDBTraceLog(LogType.Error, 'Exception occured while checking reschedule eligibility on landing, Error: ' + e.message.substring(0, 500));
        }

    }

    // #endregion

    //#region Time Slots

    //Upon timeslot selection capture the details to show on next screen
    public SelectTimeSlot(event, timeSlotSelected, startTime, finishTime, scheduleWindow) {
        try {
            var tsDate = timeSlotSelected.substring(0, timeSlotSelected.indexOf(" ")).trim();
            var tsWindow = '';
            var tsWindowFrom = '';
            var tsWindowTo = '';

            if (timeSlotSelected.indexOf("(") > 0)
                tsWindow = timeSlotSelected.substring(timeSlotSelected.indexOf(" ") + 1, timeSlotSelected.indexOf("(")).trim();
            else
                tsWindow = timeSlotSelected.substring(timeSlotSelected.indexOf(" ") + 1).trim();

            if (tsWindow != '' && tsWindow.indexOf('-') > 0) {
                tsWindowFrom = tsWindow.split('-')[0].trim();
                tsWindowTo = tsWindow.split('-')[1].trim();

                if (tsWindowFrom.startsWith('0', 0))
                    tsWindowFrom = tsWindowFrom.substring(1);

                if (tsWindowTo.startsWith('0', 0))
                    tsWindowTo = tsWindowTo.substring(1);

                tsWindow = tsWindowFrom + ' - ' + tsWindowTo;
            }

            var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
            var d = new Date(tsDate);
            var dayName = days[d.getDay()];

            this.selectedTimeSlot = dayName + "," + this.datepipe.transform(tsDate, " MMM dd, yyyy");
            this.selectedTimeSlotWindow = tsWindow;
            this.selectdScheduleDate = startTime;
            this.selectedScheduleWindow = scheduleWindow;
            this.ccbAppointmentStart = this.datepipe.transform(startTime, "yyyy-MM-dd") + "-" + this.datepipe.transform(startTime, "HH.mm.ss");
            this.ccbAppointmentEnd = this.datepipe.transform(finishTime, "yyyy-MM-dd") + "-" + this.datepipe.transform(finishTime, "HH.mm.ss");

            //Prepare output object and emit to parent component.
            this.EmitOutputToParent();

            this.insertDBTraceLog(LogType.Info, 'Timeslot selected for ' + this.datepipe.transform(tsDate, "MMddyyyy") + ', ' + tsWindow);
        }
        catch (e) {
            this.insertDBTraceLog(LogType.Error, 'Exception occured while selecting time slot, Error: ' + e.message.substring(0, 500));
        }
    }

    public LoadSelectedDayTimeSlots(event, selectedAvailableDay) {
        try {
            var selectedDate = selectedAvailableDay.availableDate;

            this.firstSentinelAvailableDate = selectedDate;

            /*Begin - Highlight selected date*/
            if (event != null) {
                //var target = event.target || event.srcElement || event.currentTarget;
                var target = event.currentTarget;

                //Change selected button (if not enabled) Css class
                if (selectedAvailableDay != null && <Boolean>selectedAvailableDay.enabled)
                    $(event.srcElement).addClass("btn btn-default btn-sm btnFillStrongRed");

                //Loop through all buttons available in div
                $('#divAvailableDay').children('button').each(function () {

                    //console.log("Button: ", $(this)[0]);

                    //if selected button and looping button is NOT same && looping button is disabled do not make class adjustments
                    if ((target.id).toString() != $(this)[0].id && !(($(this)[0] as HTMLButtonElement).disabled) && $(this)[0].id != 'btnMoreDates') {
                        $(this).removeClass();
                        $(this).addClass("btn btn-default btn-sm");
                    }

                });
            }
            /*End - Highlight selected date*/

            //Invoke eligibility service on selected date for only AGLC and where matched order found, as matched order validations are not being checked for CCB.        
            if (this.matchOrderEffectiveDate != null && this.ldc === 'AGLC' && this.appointmentType !='Issue') {
                this.showTimeSlotLoadingSpinner = true;
                this.GetRescheduleEligibilityOnSelectedDate(selectedDate);
            }
            else
                this.LoadFilteredTimeSlots(selectedDate);
        }
        catch (e) {
            this.insertDBTraceLog(LogType.Error, 'Exception occured while loading timeslots for selected day, Error: ' + e.message.substring(0, 500));
        }
    }
    
    public LoadFilteredTimeSlots(selectedDate) {
        try {

            var tsWindowFrom = '';
            var tsWindowTo = '';

            /*Filter time slots for selected date*/
            this.filteredTimeSlots = [];
            this.sentinelAvailableDays.forEach(availableDay => {
                if (availableDay.availableDate == this.datepipe.transform(selectedDate, "yyyy-MM-dd")) {
                    availableDay.timeSlots.forEach(timeSlot => {

                        //check for duplicate timeslots before pushing
                        if (this.filteredTimeSlots.length == 0 || (this.filteredTimeSlots.length > 0 && !this.filteredTimeSlots.some((el) => el.displayTimeSlot == timeSlot.displayTimeSlot)))

                            //Remove leading zero from Display TimeSlot    
                            if (timeSlot.displayTimeSlot.indexOf('-') > 0) {
                                tsWindowFrom = timeSlot.displayTimeSlot.split('-')[0].trim();
                                tsWindowTo = timeSlot.displayTimeSlot.split('-')[1].trim();

                                if (tsWindowFrom.startsWith('0', 0))
                                    tsWindowFrom = tsWindowFrom.substring(1);

                                if (tsWindowTo.startsWith('0', 0))
                                    tsWindowTo = tsWindowTo.substring(1);

                                timeSlot.displayTimeSlot = tsWindowFrom + ' - ' + tsWindowTo;
                            }

                        this.filteredTimeSlots.push(timeSlot);
                    });

                }
            });

        }
        catch (e) {
            this.insertDBTraceLog(LogType.Error, 'Exception occured while filtering timeslots, Error: ' + e.message.substring(0, 500));
        }
    }

    //#endregion

    // #region Button & Scroll events

    public onPreviousSearchPosition(): void {

        //enable right arrow on click of left arrow btn
        this.ToggleRightArrow(false);

        var container = document.getElementById('divAvailableDay');
        var scrollAmount = 0;
        var slideTimer = setInterval(function () {
            container.scrollLeft -= 5;
            scrollAmount += 5;
            if (scrollAmount >= 100) {
                clearInterval(slideTimer);
            }
        }, 25);


        var $width = container.offsetWidth;
        var $scrollWidth = container.scrollWidth;
        var $scrollLeft = 0;


        if (container.scrollLeft >= 0)
            $scrollLeft = container.scrollLeft - 100;
        else
            $scrollLeft = container.scrollLeft;

        if ($scrollLeft <= 0) {
            this.ToggleLeftArrow(true);
        }

    }

    public onNextSearchPosition(): void {

        //by default left arrow will be disabled. Once right arrow is clicked enable left arrow.
        this.ToggleLeftArrow(false);

        //move div scroll
        var container = document.getElementById('divAvailableDay');
        var scrollAmount = 0;
        var slideTimer = setInterval(function () {
            container.scrollLeft += 5;
            scrollAmount += 5;
            if (scrollAmount >= 100) {
                clearInterval(slideTimer);
            }
        }, 25);


        //disable rigt arrow at the right end of  scrolling
        var $width = container.offsetWidth + 34;
        var $scrollWidth = container.scrollWidth;
        var $scrollLeft = container.scrollLeft;

        if ($scrollWidth - $width === $scrollLeft) {
            this.ToggleRightArrow(true);
        }

    }

    /* Toggle enable/disable on Left & Right arrow buttons during scrolling */
    onScroll(event: Event) {
        //console.log((event.target as HTMLElement).scrollLeft);
        var container = document.getElementById('divAvailableDay');
        var containerTarget = event.target;

        var $width = container.offsetWidth;
        var $scrollWidth = container.scrollWidth;
        var $scrollLeft = container.scrollLeft;

        if ($scrollWidth - $width === $scrollLeft) {

            this.ToggleRightArrow(true);
        }
        else if ($scrollLeft <= 0) {
            this.ToggleLeftArrow(true);
        }
        else {

            this.ToggleLeftArrow(false);
            this.ToggleRightArrow(false);
        }
    }

    ToggleLeftArrow(disable: boolean) {

        if (disable) {
            ($('#left-button')[0] as HTMLButtonElement).disabled = true;
            ($('#left-button')[0] as HTMLButtonElement).innerHTML = '<i class="material-icons md-36" style="color: #808080; font-size: 36px;">keyboard_arrow_left</i>';
        }
        else {
            ($('#left-button')[0] as HTMLButtonElement).disabled = false;
            ($('#left-button')[0] as HTMLButtonElement).innerHTML = '<i class="material-icons md-36" style="color: #c23225; font-size: 36px;"">keyboard_arrow_left</i>';
        }
    }

    ToggleRightArrow(disable: boolean) {

        if (disable) {
            ($('#right-button')[0] as HTMLButtonElement).disabled = true;
            ($('#right-button')[0] as HTMLButtonElement).innerHTML = '<i class="material-icons md-36" style="color: #808080; font-size: 36px;"">keyboard_arrow_right</i>';
        }
        else {
            ($('#right-button')[0] as HTMLButtonElement).disabled = false;
            ($('#right-button')[0] as HTMLButtonElement).innerHTML = '<i class="material-icons md-36" style="color: #c23225; font-size: 36px;"">keyboard_arrow_right</i>';
        }
    }

    LoadMoreDates() {
        try {
            var sentinelNextSeedDate: Date;
            var maxSentinelAvailableDate;

            if (this.sentinelAvailableDays.length > 0) {
                maxSentinelAvailableDate = this.sentinelAvailableDays[this.sentinelAvailableDays.length - 1].availableDate;

                //converting below format is required to add days to date.
                sentinelNextSeedDate = new Date(this.datepipe.transform(maxSentinelAvailableDate, "yyyy/MM/dd"));

                //modify seedDate to +1 for NoGas to get next day            
                if (this.ldc === 'AGLC' && Object.values(NoGasClickOrderModel).includes(this.orderType,null)) {
                    sentinelNextSeedDate = new Date(sentinelNextSeedDate.setDate(sentinelNextSeedDate.getDate() + 1));
                }

                this.showTimeSlotLoadingSpinner = true;

                this.insertDBTraceLog(LogType.Info, 'Requested to load more dates for seed date: ' + this.datepipe.transform(sentinelNextSeedDate, "MMddyyyy"));
                
                this.GetAvailability(this.datepipe.transform(sentinelNextSeedDate, "yyyy-MM-dd"), false);
            }

        }
        catch (e) {
            this.insertDBTraceLog(LogType.Error, 'Exception occured while loading more dates, Error: ' + e.message.substring(0, 500));
        }
    }

    //#endregion

    //#region Private Helper Methods

    private GetAvailabilityInput() {

        this.ldc = this.availabilityInput.ldc;
        this.urlCode = this.availabilityInput.kmiUrlCode;
        this.orderNumber = this.availabilityInput.orderNumber;
        this.orderType = this.availabilityInput.orderType;
        this.premiseNumber = this.availabilityInput.premisesNumber;
        this.portalTypeID = this.availabilityInput.portalTypeID;
        this.logReferenceID = this.availabilityInput.logReferenceID;
        this.entranceCodeReminderMsg = this.availabilityInput.entranceCodeReminderMsg;        
        this.emailToList = this.availabilityInput.emailToList;
        this.appointmentType = this.availabilityInput.appointmentType;
    }

    private EmitOutputToParent() {

        this.availabilityOutput.selectedTimeSlot = this.selectedTimeSlot;
        this.availabilityOutput.selectedTimeSlotWindow = this.selectedTimeSlotWindow;
        this.availabilityOutput.selectedScheduleDate = this.selectdScheduleDate;
        this.availabilityOutput.selectedScheduleWindow = this.selectedScheduleWindow;
        this.availabilityOutput.ccbAppointmentStart = this.ccbAppointmentStart;
        this.availabilityOutput.ccbAppointmentEnd = this.ccbAppointmentEnd;
        
        this.availabilitySelectionEvent.emit(this.availabilityOutput);
    }

    private insertDBTraceLog(logType: string, logMessage: string) {

        this.dbTraceLog = new DBTraceLog();

        this.dbTraceLog.portalTypeID = this.portalTypeID; //From parent
        this.dbTraceLog.ldc = this.ldc;
        this.dbTraceLog.kmiUrlCode = this.urlCode;
        this.dbTraceLog.issuingApOrderID = this.orderNumber;
        this.dbTraceLog.orderType = this.orderType;
        this.dbTraceLog.logReferenceID = this.logReferenceID;
        this.dbTraceLog.logType = logType;
        this.dbTraceLog.logMessage = logMessage;            
        this.dbTraceLog.emailToList = this.emailToList;

        super.InsertDBTraceLogThruBase(this.dbTraceLog);
    }

    processError(): void {       
        this.showSpinner = false;
        this.showTimeSlotLoadingSpinner = false;   

        this.processErrorEvent.emit();

    }
    
    //#endregion

}

